import ToolTip from "./ToolTip";
export default ToolTip;
